var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:{
      btn: true,
      'btn-sm': true,
      'btn-primary': _vm.isFavoritedOptimistic,
      'btn-outline-primary': !_vm.isFavoritedOptimistic,
    },on:{"click":_vm.handleLike}},[_c('i',{staticClass:"ion-heart"}),_c('span',[_vm._v("  "+_vm._s(_vm.favoritesCountOptimistic))])])])}
var staticRenderFns = []

export { render, staticRenderFns }